// import state from './state';
import XEUtils from 'xe-utils' // 工具类
import router from '@/router'
export default {
  isParentDept(state) {
    return state.userInfo.isParentDept === 'Y'
  },
  // 是否管理企业
  isManageEnt(state) {
    return state.userInfo.deptType === '0'
  },
  // 主菜单列表扁平化为数组
  platMainMenus(state) {
    const routes = router.getRoutes()
    const maiMenusList = XEUtils.toTreeArray(state.menus)

    maiMenusList.map((item) => {
      const route = routes.find((r) => r.path === item.link)
      // 添加部分路由信息
      if (route) {
        item.meta = route.meta
        item.name = route.name
      }
      return item
    })
    return maiMenusList
    // return maiMenusList.map(item => {
    //   const route = routes.find(r => r.path === item.link);
    //   // 添加部分路由信息
    //   if (route) {
    //     item.meta = route.meta;
    //     item.name = route.name;
    //   }
    //   return item;
    // });
  },
}
